import * as assetsHelpers from '../../../helpers/assets';
import Logger from '../../../services/Logger';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';
import Toast from '../../../components/Toast';
import TYPES from '../../action-types';

import checkMultipleChanges from './checkMultipleChanges';
import { reloadCurrentPage } from '../../../helpers/history';

/**
 * Change title on assets
 * @param {string[]} ids
 * @param {string} title
 * @param {Function} onCancel
 */
const changeTitle = (ids, title, onCancel) => (dispatch, getAll) => {
  checkMultipleChanges(ids.length, doChange, onCancel);

  async function doChange() {
    try {
      dispatch({ type: TYPES.ASSETS.CHANGE_TITLE.START });

      await assetsHelpers.setTitle(ids, title);

      dispatch({
        type: TYPES.ASSETS.CHANGE_TITLE.COMPLETE,
        payload: { ids, title, userId: getAll().user._id },
      });
    } catch (error) {
      const errorStatus = utils.getStatusFromResponceError(error);
      const errorMessage = errorStatus === 403
        ? localization.NO_PERMISSION_TO_ACCESS
        : localization.DETAILS.textCantUpdate('title');
      Toast(errorMessage, { autoClose: false, type: 'error', onOk: reloadCurrentPage, btnOkValue: localization.HISTORY.textBtnRefresh });
      dispatch({ type: TYPES.ASSETS.CHANGE_TITLE.FAILED, error });
      Logger.error(new Error('Error change title'), { error }, [
        'ChangeTitleFailed',
        (error && error.message) || 'NoMessage',
      ]);
    }
  }
};

export default changeTitle;
